<template>
  <div style="display:inline-block;">
    <div class="need-install" v-if="!isInstalled">
      <span>
        <img src="@/assets/img/icon/u1488.png" alt="" />
        初次使用远程时，请先下载并安装
        <a :href="$PAGE_API.other.downloadPlugin" target="_blank">远控插件</a>
        !</span
      >
    </div>
    <div class="need-install" v-if="needUpdate && isInstalled">
      <span>
        <img src="@/assets/img/icon/u1488.png" alt="" />
        远控插件有新版本
        <a :href="$PAGE_API.other.downloadPlugin" target="_blank">点击更新</a>
        !</span
      >
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      isInstalled: (state) => state.plugin.isInstalled,
      needUpdate: (state) => state.plugin.needUpdate,
    }),
  },
}
</script>

<style lang="scss" scoped>
.need-install {
  display: inline-block;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgba(252, 248, 226, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(251, 236, 203, 1);
  color: #f68300;
  img {
    float: left;
    margin-top: 8px;
    margin-right: 5px;
  }
  a {
    color: #f68300;
    font-weight: 600;
    text-decoration: underline;
  }
}
</style>
